import type { Course, CourseDeleteOutcome } from '@/types/composition-functions';

/**
 * Label for a course the bulk delete kept. The outcome only carries the id and
 * (for a course that still exists) its code, so the rows the user selected are
 * the source of the title; a course that vanished between selecting and
 * deleting gets a plain-English label, never "#123".
 */
export type SelectedCourseRow = Partial<Pick<Course, 'course_code' | 'course_title'>> & { id: Course['id'] | number };

export function blockedCourseLabel(outcome: Pick<CourseDeleteOutcome, 'id' | 'course_code'>, selected: ReadonlyArray<SelectedCourseRow>): string {
  const row = selected.find((r) => String(r.id) === String(outcome.id));
  const parts = [row?.course_code ?? outcome.course_code, row?.course_title]
    .map((p) => (p ?? '').trim())
    .filter(Boolean);
  return parts.length ? parts.join(' ') : 'Course no longer exists';
}
